import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import {
  useDeleteQrCodeByBatchIdMutation,
  useFetchAllQrCodeMutation,
  useFetchQrCodeByGenerationIDMutMutation,
} from "../../../features/tenant/qrCode/qrCodeApi";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { AiOutlineCloudDownload } from "react-icons/ai";


const QrPrint = () => {
  const navigate = useNavigate();


  const [myList, setMyList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState('csv'); // 'csv' or 'xlsx'

  const currentDate = new Date().toISOString().split("T")[0];
  const initialRequest = {
    product_code: "",
    product_name: "",
    batch_code: "",
    limit: 10,
    offset: 0,
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);
  const clearFilters = () => {
    setRequest(initialRequest);
  };

  useEffect(() => {
    if (
      request.product_code === "" &&
      request.product_name === "" &&
      request.batch_code === "" &&
      request.startDate === "" &&
      request.endDate === ""
    ) {
      fetchAllQrCodeFunction();
    }
  }, [request]);

  const [
    fetchAllQrCode,
    {
      data: qrListData,
      isLoading: qrListDataIsLoading,
      isError: qrListDataIsError,
      error: qrListDataError,
    },
  ] = useFetchAllQrCodeMutation();

  useEffect(() => {
    fetchAllQrCodeFunction();
  }, []);

  useEffect(() => {
    if (qrListData) {
      setMyList(qrListData?.body?.batchCodes ? qrListData?.body?.batchCodes : []);
      setTotalRows(qrListData?.body?.total_batchcodes ? qrListData?.body?.total_batchcodes : 0);
    }
  }, [qrListData]);

  const fetchAllQrCodeFunction = () => {
    fetchAllQrCode({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const [
    deleteQrCode,
    {
      data: deleteQrCodeData,
      isLoading: deleteQrCodeIsLoading,
      isError: deleteQrCodeIsError,
      error: deleteQrCodeError,
    },
  ] = useDeleteQrCodeByBatchIdMutation();

  const handleDelete = (batchId) => {
    if (window.confirm("are you sure you want to delete ?")) {
      deleteQrCode({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        batchId: batchId,
      });
    }
    return;
  };

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  useEffect(() => {
    toast.dismiss();

    if (deleteQrCodeData) {
      toast.success("Qr Code Batch deleted", { id: "deleteQrCodeSuccess" });
      fetchAllQrCodeFunction("");
    }

    if (deleteQrCodeError) {
      toast.error("Some error occured", { id: "deleteQrCodeError" });
    }
  }, [deleteQrCodeData, deleteQrCodeIsLoading, deleteQrCodeError]);

  const [
    qrLiCsvDataFun,
    {
      data: qrLiCsvData,
      isLoading: qrLiCsvDataIsLoading,
      error: qrLiCsvDataError,
    },
  ] = useFetchQrCodeByGenerationIDMutMutation();

  useEffect(() => {
    if (qrLiCsvDataIsLoading) {
      toast.dismiss();
      toast.loading("loading ...", {
        id: "delete loading ",
      });
    }
    if (qrLiCsvData) {
      toast.dismiss();
    }
  }, [qrLiCsvDataIsLoading, qrLiCsvData]);

  const qrListDownLoad = (event, format = 'csv') => {
    setDownloadFormat(format);
    qrLiCsvDataFun({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      generationId: event.id,
    });
  };

  const generateExcel = async (data) => {
    if (!data || !data.body || !data.body.qr || data.body.qr.length === 0) {
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("QR Data");

    // Define columns
    worksheet.columns = [
      { header: "Id", key: "id", width: 10 },
      { header: "Batch Running Code", key: "batch_running_code", width: 25 },
      { header: "Unique Code", key: "unique_code", width: 40 },
      { header: "Scratch Code", key: "scratch_code", width: 20 },
      { header: "Product Code", key: "product_code", width: 20 },
      { header: "MRP", key: "mrp", width: 15 },
      { header: "Created At", key: "created_at", width: 25 },
      { header: "QR Status", key: "qr_status", width: 15 },
    ];

    // Add rows
    data.body.qr.forEach((item, index) => {
      worksheet.addRow({
        id: index + 1,
        batch_running_code: item.batch_running_code,
        unique_code: item.unique_code,
        scratch_code: item.scratch_code,
        product_code: item.product_code,
        mrp: item.mrp,
        created_at: item.created_at,
        qr_status: item.qr_status,
      });
    });

    // Formatting
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

    // Generate buffer and save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `qr_data_${new Date().getTime()}.xlsx`);
  };



  const generateCSV = (data) => {
    if (!data || !data.body || !data.body.qr) {
      return "";
    }

    if (data.body.qr.length === 0) {
      return "";
    }

    const header = [
      "Id",
      "Batch Running Code",
      "Unique Code",
      "Scratch Code",
      "Product Code",
      "MRP",
      "Created At",
      "QR Status"

    ];
    const rows = data.body.qr.map((item, index) => [
      index + 1,
      item.batch_running_code,
      item.unique_code,
      item.scratch_code,
      item.product_code,
      item.mrp,
      item.created_at,
      item.qr_status
    ]);

    const csvContent = [header, ...rows]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    return `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;
  };

  useEffect(() => {

    if (qrLiCsvData && qrLiCsvData.body) {
      console.log("qrLiCsvData.body", qrLiCsvData.body);
      let qrList2 = [...qrLiCsvData.body.qr];
      let qrList = qrList2.map(x => ({
        ...x,
        unique_code: `http://gverify.me/?${x.unique_code}`
        // unique_code: `${x.unique_code}`
      }));
      const modifiedBody = {
        ...qrLiCsvData.body,
        qr: qrList // qrList is the modified array
      };
      const newData = { body: modifiedBody }

      if (qrLiCsvData?.body?.qr.length > 0) {
        if (downloadFormat === 'csv') {
          const csvDataUri = generateCSV(newData);

          const downloadLink = document.createElement("a");
          downloadLink.href = csvDataUri;
          downloadLink.download = "qr_data.csv";
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);

          downloadLink.click();

          document.body.removeChild(downloadLink);
        } else if (downloadFormat === 'xlsx') {
          generateExcel(newData);
        }
      }

    }
  }, [qrLiCsvData]);

  // Helper to wrap cell content with tooltip for in-progress rows
  const wrapWithTooltip = (row, content) => (
    <div title={row.status == "2" ? "This batch is in progress" : ""}>
      {content}
    </div>
  );

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => (
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '6px', overflow: 'visible' }}
        >
          <span>{offset + Number(idx + 1)}</span>
          {row.status == "2" && (
            <>
              <span
                className="tooltip-container"
                style={{
                  display: 'inline-flex',
                  position: 'relative',
                  cursor: 'help',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    animation: 'rotateHourglass 1.5s ease-in-out infinite',
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 2H18V6C18 8.20914 16.2091 10 14 10H10C7.79086 10 6 8.20914 6 6V2Z"
                      stroke="#f59e0b"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6 22H18V18C18 15.7909 16.2091 14 14 14H10C7.79086 14 6 15.7909 6 18V22Z"
                      stroke="#f59e0b"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="#fcd34d"
                    />
                    <path
                      d="M12 10V14"
                      stroke="#f59e0b"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M5 2H19"
                      stroke="#f59e0b"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M5 22H19"
                      stroke="#f59e0b"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className="tooltip-text">This batch is in progress</span>
              </span>
              <style>{`
                @keyframes rotateHourglass {
                  0% { transform: rotate(0deg); }
                  50% { transform: rotate(180deg); }
                  100% { transform: rotate(180deg); }
                }
                .tooltip-container .tooltip-text {
                  visibility: hidden;
                  opacity: 0;
                  position: absolute;
                  left: 100%;
                  top: 50%;
                  transform: translateY(-50%);
                  margin-left: 8px;
                  background-color: #333;
                  color: #fff;
                  padding: 6px 10px;
                  border-radius: 6px;
                  font-size: 12px;
                  white-space: nowrap;
                  z-index: 1000;
                  transition: opacity 0.2s, visibility 0.2s;
                }
                .tooltip-container .tooltip-text::after {
                  content: '';
                  position: absolute;
                  top: 50%;
                  right: 100%;
                  transform: translateY(-50%);
                  border-width: 5px;
                  border-style: solid;
                  border-color: transparent #333 transparent transparent;
                }
                .tooltip-container:hover .tooltip-text {
                  visibility: visible;
                  opacity: 1;
                }
              `}</style>
            </>
          )}
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Product Name",
      cell: (row) => row.product_name,
      sortable: true,
      width: "200px",
    },
    {
      name: "Batch Code",
      cell: (row) => row.batch_code,
      sortable: true,
      width: "100px",
    },
    {
      name: "Qty",
      cell: (row) => row.qty,
      sortable: true,
      width: "80px",
    },
    {
      name: "Type",
      cell: (row) => (row.type == "2" ? "Enterprise" : "Standard"),
      sortable: true,
      width: "80px",
    },
    JSON.parse(sessionStorage.getItem("vendorData")).tenant_name === "cg" && {
      name: "Success Count",
      cell: (row) => row?.qr_count,
      sortable: true,
      width: "130px",
    },
    {
      name: "From Date",
      cell: (row) => new Date(row.from_date).toLocaleDateString(),
      sortable: true,
      width: "130px",
    },

    {
      name: "To Date",
      cell: (row) => new Date(row.to_date).toLocaleDateString(),
      sortable: true,
      width: "130px",
    },
    {
      name: "Generation Id",
      cell: (row) => row?.id,
      sortable: true,
      width: "80px",
    },

    JSON.parse(sessionStorage.getItem("vendorData")).tenant_name === 'seedworks' &&

    {
      name: "Lot Number",
      cell: (row) => JSON.stringify(row.details ? row.details.seedwork_batch : {}),
      sortable: true,
      width: "130px",
    },

    {
      name: "Mapped User",
      cell: (row) => row.details && Object.keys(row.details).length > 0 && <div className="flex flex-col space-y-0.5 justify-evenly items-start">
        <span>Name : {row?.name} </span>
        <span>Mobile: {row?.mobile}</span>
        <span>User Id: {row?.user_id}</span>
      </div>,
      sortable: true,
      width: "200px",
    },
    {
      name: "Created By",
      cell: (row) => row.created_by_name,
      sortable: true,
    },
    {
      name: "Created At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
    {
      name: "",
      cell: (row) => (
        <div>
          <button
            onClick={() =>
              navigate("batch", {
                state: row,
              })
            }
            className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
          >
            View
          </button>
        </div>
      ),
      minWidth: "100px",
    },
    {
      name: "Download",
      cell: (row) => (
        <div className="flex justify-center items-center overflow-visible">
          <Menu as="div" className="relative inline-block text-left">
            <div>
              <Menu.Button className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] gap-x-1.5 ">
                Download
                <AiOutlineCloudDownload className="-mr-1 h-4 w-4 text-white" aria-hidden="true" />
              </Menu.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-[1001] mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => qrListDownLoad(row, 'csv')}
                        className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                          } block w-full px-4 py-2 text-left text-xs`}
                      >
                        Download CSV
                      </button>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => qrListDownLoad(row, 'xlsx')}
                        className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                          } block w-full px-4 py-2 text-left text-xs`}
                      >
                        Download Excel
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      ),
      minWidth: "140px",
    },

    {
      name: "",
      cell: (row) =>
        row.product_name === "Mixed Imported Qrs" && (
          <div>
            <button
              onClick={() =>
                navigate("mapping", {
                  state: row,
                })
              }
              className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
            >
              Mapping
            </button>
          </div>
        ),
      minWidth: "100px",
    },

    // {
    //   name: "",
    //   cell: (row) => (
    //     <div>
    //       <button
    //         onClick={() => handleDelete(row.id)}
    //         className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]"
    //       >
    //         <AiOutlineDelete className="mr-1" />
    //         Delete
    //       </button>
    //     </div>
    //   ),
    //   minWidth: "120px",
    // },
  ];

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Qr Code Print
            <LinksComponent />
          </div>

          <div className="w-full ">
            <div className="p-3">
              <div className=" bg-white shadow rounded-lg">
                <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                  <div className="flex  space-x-2 justify-between">
                    <div className="w-52 h-10">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Batch Code
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Batch Code..."
                          required
                          value={request.batch_code}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, batch_code: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-52 h-10">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Product Name
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Product Name..."
                          required
                          value={request.product_name}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, product_name: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Product Code
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Product Code ..."
                        required
                        value={request.product_code}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, product_code: newValue };
                          });
                        }}
                      />
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Start Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Start Date"
                        value={request.startDate}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              startDate: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="End Date"
                        value={request.endDate}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              endDate: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                    <div className="flex flex-row gap-2  w-56 h-10">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          &nbsp;
                        </label>
                        <button
                          className="btn btn-outline-primary clear-both float-right pdbtn_all "
                          onClick={() => {
                            fetchAllQrCodeFunction();
                          }}
                        >
                          Search
                        </button>
                      </div>
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          &nbsp;
                        </label>
                        <button
                          className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                          onClick={() => {
                            clearFilters();
                          }}
                        >
                          Clear Filters
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {qrListDataIsLoading && <CircleLoaderComponent />}
                <DataTableComponent
                  keyField={(row) => row.SNo}
                  columns={columns}
                  data={myList.map(row => ({
                    ...row,
                    title: row.status == "2" ? "QR Generation In Progress..." : undefined
                  }))}
                  // loading={loading}
                  totalRows={totalRows}
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paginationDefaultPage={currentPage}
                  paginationResetDefaultPage={paginationResetToggle}
                  conditionalRowStyles={[
                    {
                      when: row => row.status == "2",
                      style: {
                        backgroundColor: '#eae9e5ff',
                        color: '#000000ff',
                        fontWeight: '500',
                        // cursor: 'help',
                      },
                    },
                  ]}
                ></DataTableComponent>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QrPrint;
